<template>
  <el-col :sm="24" :lg="12" class="legend">
    <div class="legend-title">
      <div>{{ $t('text.legend') }}</div>
    </div>
    <div class="legend-group" v-if="!isVoidsOnlyMode">
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div class="pad-cycle"></div>
          <div class="legend-item-text">
            {{ $t('text.pad_cycle', { pad: $store.state.locale.pad }) }}
          </div>
        </div>
        <div class="legend-item">
          <div class="off-body-item">
            <div class="off-body-left"></div>
            <img src="@/assets/image/VoidingPatternIcon/off-body.svg" />
            <div class="off-body-right"></div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.off_body') }}
          </div>
        </div>
      </div>
    </div>
    <div class="legend-group" v-if="!isVoidsOnlyMode">
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div
            class="diaper-not-selected pointer"
            :class="{
              'filter-selected': isFilterSelected(voidConst.diaperNotSelected)
            }"
            @click="updateFilters(voidConst.diaperNotSelected)"
          >
            <img
              src="@/assets/image/VoidingPatternIcon/diaper-not-selected.png"
            />
          </div>
          <div class="legend-item-text">
            {{
              $t('text.diaper_not_selected', {
                pad: $store.state.locale.pad
              }).toLowerCase()
            }}
          </div>
        </div>
        <div class="legend-item text-center">
          <div
            class="change-diaper pointer"
            :class="{
              'filter-selected': isFilterSelected(voidConst.red)
            }"
            @click="updateFilters(voidConst.red)"
          >
            <img src="@/assets/image/VoidingPatternIcon/red-icon.png" />
          </div>
          <div class="legend-item-text">
            {{
              $t('text.change_diaper', {
                pad: $store.state.locale.pad
              }).toLowerCase()
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="legend-group">
      <div class="legend-item-wrapper">
        <div class="legend-item" v-if="!isVoidsOnlyMode">
          <div
            class="diaper-capacity"
            :class="{
              'filter-selected': isFilterSelected(voidConst.padEndLevel1)
            }"
            @click="updateFilters(voidConst.padEndLevel1)"
          >
            <div class="pad-fullness pointer">
              <img src="@/assets/image/VoidingPatternIcon/pad-fullness1.png" />
            </div>
            <div class="pad-fullness pointer">
              <img src="@/assets/image/VoidingPatternIcon/pad-fullness2.png" />
            </div>
            <div class="pad-fullness pointer">
              <img src="@/assets/image/VoidingPatternIcon/pad-fullness3.png" />
            </div>
            <div class="pad-fullness pointer">
              <img src="@/assets/image/VoidingPatternIcon/pad-fullness4.png" />
            </div>
            <div class="pad-fullness pointer">
              <img src="@/assets/image/VoidingPatternIcon/pad-fullness5.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.pad_capacity', {
                pad: $store.state.locale.pad
              })
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="void-event-size"
            :class="{
              'filter-selected': isFilterSelected(voidConst.small)
            }"
            @click="updateFilters(voidConst.small)"
          >
            <div class="void-event pointer">
              <img src="@/assets/image/VoidingPatternIcon/small-void.png" />
            </div>
            <div class="void-event pointer">
              <img src="@/assets/image/VoidingPatternIcon/medium-void.png" />
            </div>
            <div class="void-event pointer">
              <img src="@/assets/image/VoidingPatternIcon/large-void.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.void_event_size') }}
          </div>
        </div>
      </div>
    </div>
    <div class="legend-group" v-if="!isVoidsOnlyMode">
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div
            class="lost-pod-connection-item pointer"
            :class="{
              'filter-selected': isFilterSelected(voidConst.outOfRange)
            }"
            @click="updateFilters(voidConst.outOfRange)"
          ></div>
          <div class="legend-item-text">
            {{ $t('text.out_of_range_legend').toLowerCase() }}
          </div>
        </div>
        <!-- <div class="legend-item">
          <div class="external-humidity">
            <div
              class="pointer"
              :class="{
                'filter-selected': isFilterSelected(voidConst.external)
              }"
              @click="updateFilters(voidConst.external)"
            >
              <img
                src="@/assets/image/VoidingPatternIcon/external-humidity.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.unstable_readings').toLowerCase() }}
          </div>
        </div> -->
        <div class="legend-item">
          <div>
            <img
              class="w-22 h-22 ml-5"
              :src="require('@/assets/image/VoidingPatternIcon/ai.svg')"
            />
          </div>
          <div class="legend-item-text">
            {{ $t('text.predicted_mode').toLowerCase() }}
          </div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
import { voidConst } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
export default {
  data() {
    return {
      voidConst,
      selectedFilter: [
        voidConst.outOfRange,
        voidConst.small,
        voidConst.medium,
        voidConst.large,
        voidConst.diaperNotSelected,
        voidConst.padStart,
        voidConst.padEndLevel1,
        voidConst.padEndLevel2,
        voidConst.padEndLevel3,
        voidConst.padEndLevel4,
        voidConst.padEndLevel5
      ]
    }
  },
  props: {
    isVoidsOnlyMode: {
      type: Boolean,
      require: true
    }
  },
  computed: {
    isFilterSelected() {
      return val => {
        return this.selectedFilter.indexOf(val) > -1
      }
    }
  },
  watch: {
    selectedFilter() {
      this.$emit('updateData')
    }
  },
  methods: {
    updateFilters(val) {
      let data = [val]
      if (val === voidConst.external) {
        data.push(voidConst.unstable)
        data.push(voidConst.clumped)
      }
      if (val === voidConst.padEndLevel1) {
        data.push(voidConst.padStart)
        data.push(voidConst.padEndLevel2)
        data.push(voidConst.padEndLevel3)
        data.push(voidConst.padEndLevel4)
        data.push(voidConst.padEndLevel5)
      }
      if (val === voidConst.small) {
        data.push(voidConst.medium)
        data.push(voidConst.large)
      }
      data.forEach(item => {
        let index = this.selectedFilter.indexOf(item)
        if (index > -1) {
          this.selectedFilter.splice(index, 1)
        } else {
          this.selectedFilter.push(item)
        }
      })
    }
  }
}
</script>
